import { ToolIcon } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { useSettingsMenuOptions } from "./useSettingsMenuOptions";
import { SettingsMenu } from "./SettingsMenu";

const HeaderSettingsMenu = () => {
  const { settingOptions, canAccessSettings, menuOpenCtrlRef } = useSettingsMenuOptions();

  return (
    <SettingsMenu
      trigger={
        <ToolIcon
          name="gear"
          size="medium"
          title={appstr("Settings")}
          ariaLabel={appstr("Settings")}
          dataTestId={"settings-gear-menu"}
          shape="round"
        />
      }
      settingOptions={settingOptions}
      canAccessSettings={canAccessSettings}
      menuOpenCtrlRef={menuOpenCtrlRef}
    />
  );
};

export default HeaderSettingsMenu;
